export const CustomDropdownItemStyles = () => (
  <style>{`
  .time-limit-item[data-disabled] {
    user-select: none;
    cursor: default;
  }

  .time-limit-item:not([data-disabled]):focus {
    outline: none;
    background-color: #f9f9f9;
  }

  .time-limit-item:not([data-disabled]):focus span.text-ds-natural,
  .time-limit-item:not([data-disabled]):focus .icon-wrapper *{
    color: #37363f;
    fill: #37363f;
  }

  .time-limit-item::not([data-disabled]):active .icon-wrapper *,
  .time-limit-item::not([data-disabled]):active span.text-ds-natural {
    color: #37363f;
    fill: #37363f;
  }

  .time-limit-item[data-disabled] span.text-ds-natural,
  .time-limit-item[data-disabled] .icon-wrapper {
    opacity: 0.5;
  }
  `}</style>
);
